// tslint:disable: no-any
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from '@core/auth/auth.service';

const UNAUTHORIZED_STATUS_CODE = 403;

@Injectable()
export class Catch403Interceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private router: Router) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.url.includes('auth')) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (UNAUTHORIZED_STATUS_CODE === err.status) {
          this.router.navigate(['home']);
        }

        return throwError(err);
      })
    );
  }
}
